$(document).on('click', '.plusBtn, .minusBtn', function () {
  setTimeout(function () {
    // $('.cart-count-bubble, .header__cart, .site-header__cart')
    //   .first()
    //   .trigger('click');
    jQuery('.all_selected_prices').load(location.href + ' .all_selected_prices');
    jQuery('.header__icon--cart').removeClass('cartEmpty');
    console.log('cart total update at plus and minus');
  }, 1000);
});


// jQuery('.cart__contents').load(location.href + ' .drawer__cart-items-wrapper');



document.addEventListener("DOMContentLoaded", function () {


  const interval = setInterval(() => {
    const formEmbed = document.querySelector('form-embed#app-embed');
    if (formEmbed && formEmbed.shadowRoot) {
      const style = document.createElement("style");
      style.textContent = `
        section[aria-label] {
          margin-bottom: 15px !important;
          background-color: #ecf7e6;
          border-radius: 14px;
          max-width: 100% !important;
        }
        section[aria-label] form {
          padding: 44px 59px;
          flex-wrap: wrap;
          flex-direction: unset;
          gap: 30px;
          justify-content: flex-end;
        }
        section[aria-label] form div:nth-child(1),
        section[aria-label] form div:nth-child(2),
        section[aria-label] form div:nth-child(3),
        section[aria-label] form div:nth-child(4),
        section[aria-label] form div:nth-child(5),
        section[aria-label] form div:nth-child(6){
          width: calc(50% - 15px);
          flex: calc(50% - 15px);
        }
        .phone-country-selector,
        .phone-country-selector + div,
        .phone-country-selector div {
          width: unset !important;
          flex: unset !important;
        }    
        section[aria-label] form div:nth-child(7) {
          width: 100% !important;
          flex: 0 0 100% !important;
        }     
        ._formSubmitButton_cit2d_96 {
          background-color: #ec008c !important;
          color: #fff !important;
          border-radius: 14px !important;
          padding: 17px 47px !important;
          font-weight: bold !important;
        }
      `;
      formEmbed.shadowRoot.appendChild(style);
      clearInterval(interval);
    }
  }, 200);
});

window.onload = function () {
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  items.forEach(item => {
      item.addEventListener("mouseover", () => {
          item.removeAttribute("open");
        item.setAttribute("open", true);
        // console.log("open true");
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
          // console.log("open 01");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        // console.log("open 02");
      });
    });
  });

  setTimeout(function () {
    var imgUrl =
      "https://cdn.shopify.com/s/files/1/0959/2012/8346/files/Group_232.png?v=1752063107";
    var imgElement = $("<img>")
      .attr("src", imgUrl)
      .attr("alt", "Cookies Banner Image");

    $(".shopify-pc__banner__wrapper").prepend(imgElement);
    $(".shopify-pc__banner__dialog").css("display", "block");
  }, 1000); // delay in milliseconds (2000ms = 2 seconds)
};
AOS.init();

